import React, { useState, useEffect } from "react";
import "./Library.css";
import DynamicBanner from "../../include/DynamicBanner";
import api from "../../../../api";
import StickyNav from "./Partials/StickyNav";
import LatestNewsMarquee from "./Partials/LatestNewsMarquee";

const Openaccess = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Banner State
  const [bannerTitle, setBannerTitle] = useState("");
  const [bannerImagesDesktop, setBannerImagesDesktop] = useState([]);
  const [bannerImagesMobile, setBannerImagesMobile] = useState([]);

  const [showAllRows, setShowAllRows] = useState(false);

  useEffect(() => {
    const fetchOpenAccessData = async () => {
      try {
        const response = await api.get("/api/sitepages/about-us/libraryopenaccess");
        const apiData = response.data;

        /** ---------------------
         * BANNER DATA
         * --------------------- */
        const banner = apiData.banner_data;

        if (banner) {
          setBannerTitle(banner.title || "");
          setBannerImagesDesktop(banner.desktop_images || []);
          setBannerImagesMobile(banner.mobile_images || []);
        }

        setData(apiData);
      } catch (err) {
        console.error("Error fetching open access data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOpenAccessData();
  }, []);

  if (loading || !data) return null;

  /** ----------------------------
   * MAIN SECTION (SAFE ACCESS)
   * ---------------------------- */
  const section =
    data.groups?.[0]?.main_section?.open_access_section ||
    data.groups?.[1]?.main_section?.open_access_section;

  if (!section) return null;

  const { title, resources, initial_visible_rows } = section;

  const visibleRows = showAllRows
    ? resources
    : resources.slice(0, initial_visible_rows);

  return (
    <>
  <section className="library-page pb_80">

  {(bannerImagesDesktop.length > 0 || bannerImagesMobile.length > 0) && (
    <DynamicBanner
      title={bannerTitle}
      bgImage={bannerImagesDesktop}
      bgImageMobile={bannerImagesMobile}
    />
  )}

  <LatestNewsMarquee />
  <StickyNav />

  {/* TABLE SECTION */}
  <div className="container">
    <div className="sec-title text-center">
      <h2>{title}</h2>
    </div>

    {/* SCROLL ONLY TABLE — NOT BUTTON */}
    <div className="table-responsive">
      <table className="table table-bordered table-hover resource-table">
        <thead>
          <tr>
            <th width="10%">S.No</th>
            <th width="40%">Resource</th>
            <th width="50%">Link</th>
          </tr>
        </thead>

        <tbody>
          {visibleRows.map((resource) => (
            <tr key={resource.sno}>
              <td>{resource.sno}</td>
              <td>{resource.resource}</td>
              <td>
                <a
                  href={resource.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {resource.link}
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>

  {/* READ MORE BUTTON OUTSIDE — FIXED & NOT SCROLLING */}
  {resources.length > initial_visible_rows && (
    <div className="text-center mt-3 mb-3">
      <button
        onClick={() => setShowAllRows(!showAllRows)}
        className="btn btn-about"
      >
        {showAllRows ? "Read Less" : "Read More"}
      </button>
    </div>
  )}

</section>

    </>
  );
};

export default Openaccess;
